import {
  AmountActions,
  INIT_AMOUNT,
  SET_AMOUNT_INPUTS,
  SET_AMOUNT_RESULT,
  SET_EXTRA_DEPOSIT,
} from '../actions/actionTypes'
import { IAmountCalc } from '../store/createStore'

const amountReducer = (
  state: IAmountCalc,
  action: AmountActions,
): IAmountCalc => {
  switch (action.type) {
    case INIT_AMOUNT:
      return {
        ...state,
        amountInputs: action.inputs,
        amountResult: action.result,
      }
    case SET_AMOUNT_INPUTS:
      return { ...state, amountInputs: action.inputs }
    case SET_AMOUNT_RESULT:
      const result = action.result
      if (result.cumulativeAmount < 0) {
        result.cumulativeAmount = 0
      }
      if (result.targetAmount < 0) {
        result.targetAmount = 0
      }
      return { ...state, amountResult: result }
    case SET_EXTRA_DEPOSIT:
      const newInputs = { ...state.amountInputs }
      newInputs.deposit = 0
      return {
        ...state,
        hasExtraDeposit: action.hasExtraDeposit,
        amountInputs: newInputs,
      }
    default:
      return { ...state }
  }
}

export default amountReducer
